import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/toaster";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollProgress from "./components/ScrollProgress";
import CookieConsent from "./components/CookieConsent";
import GoogleAnalytics from "./components/GoogleAnalytics";
import useTabLeaveHook from "./hooks/useTabLeaveHook";
import HomePage from "./pages/HomePage";
import LeistungenPage from "./pages/LeistungenPage";
import ErfolgePage from "./pages/ErfolgePage";
import TeamPage from "./pages/TeamPage";
import KontaktPage from "./pages/KontaktPage";
import ImpressumPage from "./pages/ImpressumPage";
import DatenschutzPage from "./pages/DatenschutzPage";
import VideoSkriptPage from "./pages/tools/VideoSkriptPage";
import SocialMediaCheckPage from "./pages/tools/SocialMediaCheckPage";
import { AuthProvider } from "./contexts/AuthContext";
import LoginPage from "./pages/admin/LoginPage";
import AdminLayout from "./pages/admin/AdminLayout";
import DashboardPage from "./pages/admin/DashboardPage";
import LeadsPage from "./pages/admin/LeadsPage";
import AdminErfolgePage from "./pages/admin/ErfolgePage";
import TeamAdminPage from "./pages/admin/TeamPage";
import TestimonialsAdminPage from "./pages/admin/TestimonialsPage";
import NewsletterAdminPage from "./pages/admin/NewsletterPage";
import HomepageAdminPage from "./pages/admin/HomepagePage";

const Layout = ({ children }) => (
  <div className="bg-white text-neutral-950 min-h-screen overflow-x-hidden">
    <ScrollProgress />
    <Header />
    <main>{children}</main>
    <Footer />
    <CookieConsent />
  </div>
);

const TabHookRunner = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  // Disable beforeunload prompt on admin routes so form work isn't interrupted;
  // still swap title on visibility change everywhere.
  useTabLeaveHook({ enableUnloadPrompt: !isAdmin });
  return null;
};

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <TabHookRunner />
            <GoogleAnalytics />
            <Routes>
              <Route path="/" element={<Layout><HomePage /></Layout>} />
              <Route path="/leistungen" element={<Layout><LeistungenPage /></Layout>} />
              <Route path="/erfolge" element={<Layout><ErfolgePage /></Layout>} />
              <Route path="/team" element={<Layout><TeamPage /></Layout>} />
              <Route path="/kontakt" element={<Layout><KontaktPage /></Layout>} />
              <Route path="/impressum" element={<Layout><ImpressumPage /></Layout>} />
              <Route path="/datenschutz" element={<Layout><DatenschutzPage /></Layout>} />
              <Route path="/tools/video-skript" element={<Layout><VideoSkriptPage /></Layout>} />
              <Route path="/tools/social-media-check" element={<Layout><SocialMediaCheckPage /></Layout>} />

              {/* Admin */}
              <Route path="/admin/login" element={<LoginPage />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<DashboardPage />} />
                <Route path="leads" element={<LeadsPage />} />
                <Route path="erfolge" element={<AdminErfolgePage />} />
                <Route path="team" element={<TeamAdminPage />} />
                <Route path="testimonials" element={<TestimonialsAdminPage />} />
                <Route path="newsletter" element={<NewsletterAdminPage />} />
                <Route path="homepage" element={<HomepageAdminPage />} />
              </Route>
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
      <Toaster />
    </div>
  );
}

export default App;
